import { OpcaoMenu } from '../../../shared/menus/opcao-menu.interface';

const tituloMenuLateral = '3. Acesso e oferta educacional';
const caminhoImagemLateral = '../../../assets/icone-andarilho.svg';
const corFundoLateral = '#e63d25';

const opcoesMenusLateralAtivas: OpcaoMenu[] = [
  {
    rotulo: 'Diagnóstico de matrícula',
    caminho: '/acesso-oferta-educacional/diagnostico-matricula',
    selecionado: false,
  },
  {
    rotulo: 'Projeção da oferta de matrículas por escola',
    caminho: '/acesso-oferta-educacional/projecao-da-oferta',
    selecionado: false,
  },
  {
    rotulo: 'Resultado da Projeção de Matrículas',
    caminho: '/acesso-oferta-educacional/resultado-projecao',
    selecionado: false,
  },
];

export {
  opcoesMenusLateralAtivas,
  tituloMenuLateral,
  caminhoImagemLateral,
  corFundoLateral,
};
